import React from 'react';
import CreatePost from "../domain/createEditPost/createPost";

const CreatePostPage = () => {
    return (
        <div>
            <CreatePost />
        </div>
    );
};

export default CreatePostPage;